import tabs from "../../../utils/tabs/tab.js";

const popularPlans = () => {
    
        tabs()
    
}

export default popularPlans;